import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-6 space-y-5" }

import { FormInput } from "@easy/ui/forms";
import { CardToggle } from "@easy/ui/cards";
import { PageSidebar } from "@easy/ui/page-components";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import BlockImage from "@/apps/page/project/sidebar/sections/block/BlockImage.vue";
import { useActions, useState } from "@/store/vuex-composition-mappers";
import CustomDomains from "@/apps/page/project/sidebar/settings/CustomDomains.vue";

// @ts-expect-error

export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarSettings',
  setup(__props) {

const { page, hasChanges } = useState("page", ["page", "hasChanges"]);
// @ts-expect-error
const { saveSnapshot } = useActions("page/projects", ["saveSnapshot"]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PageSidebar), null, {
    sidebarTitle: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("page.menu.settings")), 1)
    ]),
    sidebarMain: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(FormInput), {
          title: _ctx.$t('page.settings.page_title'),
          placeholder: _ctx.$t('page.settings.page_title_placeholder'),
          modelValue: _unref(page).settings.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(page).settings.title) = $event))
        }, null, 8, ["title", "placeholder", "modelValue"]),
        _createVNode(_unref(FormInput), {
          title: _ctx.$t('page.settings.page_description'),
          placeholder: _ctx.$t('page.settings.page_description_placeholder'),
          modelValue: _unref(page).settings.description,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(page).settings.description) = $event))
        }, null, 8, ["title", "placeholder", "modelValue"]),
        _createVNode(BlockImage, {
          title: _ctx.$t('page.settings.image'),
          modelValue: _unref(page).settings.image,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(page).settings.image) = $event))
        }, null, 8, ["title", "modelValue"]),
        _createVNode(BlockImage, {
          title: _ctx.$t('page.settings.favicon'),
          modelValue: _unref(page).settings.favicon,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(page).settings.favicon) = $event))
        }, null, 8, ["title", "modelValue"]),
        _createVNode(BlockImage, {
          title: _ctx.$t('page.settings.webclip'),
          modelValue: _unref(page).settings.webclip,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(page).settings.webclip) = $event))
        }, null, 8, ["title", "modelValue"])
      ]),
      _createVNode(_unref(CardToggle), {
        title: _ctx.$t('page.settings.custom_domains.title')
      }, {
        default: _withCtx(() => [
          _createVNode(CustomDomains, {
            pageUuid: _unref(page).uuid
          }, null, 8, ["pageUuid"])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    sidebarFooter: _withCtx(() => [
      _createVNode(cSaveButton, {
        onSave: _unref(saveSnapshot),
        disabled: !_unref(hasChanges)
      }, null, 8, ["onSave", "disabled"])
    ]),
    _: 1
  }))
}
}

})